import React from 'react';
import { useTranslation } from 'react-i18next';

const DashboardFooter: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="dashboard-footer">
      <div className="dashboard-footer-content">
        <div className="footer-branding">
          <p>{t('footer.dashboardCopyright', { year })}</p>
          <p>
            {t('footer.developedBy')}{' '}
            <a href="https://ainixit.com" target="_blank" rel="noopener noreferrer">
              Ainix IT
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
